import Splash from 'Pages/Splash';
import SecureDownload from 'Pages/SecureDownload';
import SiteHardPassword from 'Pages/SiteHardPassword';
import Convention from "Pages/Site/Convention";
import CapeTown from "Pages/Site/CapeTown";
import Hotel from "Pages/Site/Hotel";
import Programme from "Pages/Site/Programme";
import FAQ from "Pages/Site/FAQ";
import Gallery from "Pages/Site/Gallery";
import Dashboard from "Pages/Dashboard";
import Activities from "Pages/Site/Activities";
import Tokyo from "Pages/Site/Tokyo";
import Leaderboard from "Pages/Site/Leaderboard";
import Registration from "Pages/Registration";
import Speakers from "Pages/Site/Speakers";
import Download from "Pages/Download";
import Survey from "Pages/Site/Survey";

export default [
    { path: '/', component: Dashboard, guards: ['auth'] },
    { path: '/registration', component: Registration, guards: ['auth', 'group:Group 2'] },
    { path: '/secure-download/:id', component: SecureDownload },
    { path: '/site-hard-password', component: SiteHardPassword },
    { path: '/convention', component: Convention, guards: ['auth', 'profile-completed'] },
    { path: '/cape-town', component: CapeTown, guards: ['auth', 'profile-completed'] },
    { path: '/hotel', component: Hotel, guards: ['auth', 'profile-completed'] },
    { path: '/programme', component: Programme, guards: ['auth', 'profile-completed'] },
    { path: '/faq', component: FAQ, guards: ['auth', 'profile-completed'] },
    { path: '/gallery', component: Gallery, guards: ['auth', 'profile-completed'] },
    { path: '/activities', component: Activities, guards: ['auth', 'profile-completed'] },
    { path: '/tokyo', component: Tokyo, guards: ['auth', 'profile-completed'] },
    { path: '/leaderboard', component: Leaderboard, guards: ['auth', 'profile-completed'] },
    { path: '/downloadS3', component: Download, guards: ['auth', 'profile-completed'] },
    { path: '/survey', component: Survey, guards: ['auth', 'profile-completed'] },

    /*{ path: '/whos-who', component: Speakers, guards: ['auth', 'group:Group 2'] },*/
];
